import useDealerCountries from '../hooks/useDealerCountries'
import useImporterCountries from '../hooks/useImporterCountries'
import useCountryStore from '../stores/useCountryStore'
import useSearchStore from '../stores/useSearchStore'
import FlagIcon from './FlagIcon'

const CountrySelector = ({selectPlaceholder, language}) => {
    const {selectedCountry, setSelectedCountry} = useCountryStore()
    const {setSearchString, setSearchInputString} = useSearchStore()
    const {dealerCountries, dealerCountriesLoading, dealerCountriesError} = useDealerCountries(language)
    const {importerCountries, importerCountriesLoading, importerCountriesError} = useImporterCountries(language)

    if (dealerCountriesLoading || importerCountriesLoading) {
        return <select disabled={true}></select>
    }

    const mergedCountryList = {...dealerCountries, ...importerCountries}

    const handleCountryChange = event => {
        setSelectedCountry(event.target.value)
        setSearchString('')
        setSearchInputString('')
    }

    return (
        <div className={`mtt-country-selector${selectedCountry !== '' ? ' mtt-country-selector--active' : ''}`}>
            {selectedCountry !== '' && (
                <FlagIcon code={selectedCountry} width={21} height={15}/>
            )}
            <select onChange={event => handleCountryChange(event)} value={selectedCountry}>
                <option value=''>{selectPlaceholder}</option>
                {
                    Object.keys(mergedCountryList).map(key =>
                        <option value={key} key={key}>
                            {mergedCountryList[key]}
                        </option>
                    )
                }
            </select>
        </div>
    )
}

export default CountrySelector
